import SEO from './SEO';
import { getSEOData } from '../data/seoData';

interface PageSEOProps {
  pageKey: string;
  customTitle?: string;
  customDescription?: string;
  customKeywords?: string;
  noIndex?: boolean;
}

export default function PageSEO({ 
  pageKey, 
  customTitle, 
  customDescription, 
  customKeywords,
  noIndex = false 
}: PageSEOProps) {
  const seoData = getSEOData(pageKey);
  
  return (
    <SEO
      title={customTitle || seoData.title}
      description={customDescription || seoData.description}
      keywords={customKeywords || seoData.keywords}
      canonicalUrl={seoData.canonicalUrl}
      ogType={seoData.ogType}
      structuredData={seoData.structuredData}
      noIndex={noIndex}
    />
  );
}
